import { Injectable } from "@angular/core";
import { BehaviorSubject, ReplaySubject, Subject } from "rxjs";
import { UserModel } from "../models/user.model";

@Injectable({
    providedIn: 'root'
})
export class AppEvents {
    signedIn$ = new Subject<UserModel>();
    signedOut$ = new Subject<void>();
    settingsChanged$ = new Subject<UserModel>();
    connectionProblem$ = new BehaviorSubject<{ count: number, error?: any }>({ count: 0 });
    pwaEvent$ = new Subject<{ type: 'installed' | 'beforeinstallprompt' | 'error' | 'promptresponse', data?: string }>();
    online$ = new ReplaySubject<boolean>(0);

    connectionProblem(num: number, error?: any) {
        let value = this.connectionProblem$.value.count + num;
        this.connectionProblem$.next({ count: Math.min(value, 0), error });
    }
}  